import { useEffect } from "react";

const useDisableIntercom = (data) => {
  const { hideIntercom = true } = data || {};
    // Commented intercom due to freshchat integration
  // useEffect(() => {
  //   window.Intercom &&
  //     window.Intercom("update", { hide_default_launcher: hideIntercom });
  //   return () => {
  //     window.Intercom &&
  //       window.Intercom("update", { hide_default_launcher: false });
  //   };
  // }, []);
};

export default useDisableIntercom;
